import { Box } from "@mui/material";
import { Button } from "@mui/material";

 export const AddPageSlot = ({ onClick }: { onClick: () => void }) => {
  return (
    <Box
      sx={{
        height: 40,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        cursor: "pointer",
        opacity: 0,
        transition: "0.2s",
        "&:hover": {
          opacity: 1,
        },
      }}
      onClick={onClick}
    >
      <Button
        size="small"
        variant="contained"
        sx={{
          borderRadius: "999px",
          fontSize: 12,
          textTransform: "none",
          backgroundColor: "#4F46E5",
          "&:hover": { backgroundColor: "#4338CA" },
        }}
      >
        + Add Page
      </Button>
    </Box>
  );
};
